module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/vue-webpack-code-splitting-async-292.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/development/vue-webpack-code-splitting-async.md
// module id = 736
// module chunks = 206